module.exports = {
  getMessage: (field, args) => 'Telemóvel deve iniciar com o algarismo ' + args,
  validate: (value, args) => {
    var res = value[0]
    if (res === args[0]) {
      return true
    } else {
      return false
    }
  }
}
